import JSONbig from 'json-bigint';
import css from './compare.module.scss';
import PageLayout from '@/components/PageLayout';
import Crum from '@/components/Crum';
import CompareList from '@/components/CompareList';
import { capitalizeFirstChar, handleMultiProductImages, isReadyLang, redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { queryComparisonProductList, getCategoryList } from '@/service';
import ProductBanner from '@/components/ProductBanner';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/compare/series';

export default function Compare({ lang, categoryDataList, SEO }: any) {
    const { useRouter, useState, useEffect, useLang } = useGlobal();
    const { t } = useLang('shared');
    const router = useRouter();
    const {
        query: { series, id },
        locale,
    } = useRouter();

    const [compareSelectList, setCompareSelectList] = useState([]);
    const storageCategory = categoryDataList || [];

    const selectData = [
        {
            key: 'river',
            value: 'power',
            lang: t('crums.crum_power_stations'),
            category: 'product_ps',
        },
        {
            key: 'delta',
            value: 'power',
            lang: t('crums.crum_power_stations'),
            category: 'product_ps',
        },
        {
            key: 'solar',
            value: 'solar',
            lang: t('crums.crum_solar_panels'),
            category: 'product_sp',
        },
    ];
    const selectObj = selectData.find((item) => item.key === series);
    const breadcrumbData = [
        { name: t('crums.crum_home'), link: '/' },
        { name: capitalizeFirstChar(selectObj?.lang), link: `/collections/${selectObj?.value}` },
        { name: t('crums.site_product_comparison_title') },
    ];

    // 处理数据
    const dealData = (skuList: any) => {
        //  筛选出与路由series字段相同的类别
        const seriesObj = storageCategory.find((c: Record<string, string | number | null | undefined>) => c.generalKey === selectObj?.category);

        // 判断是否有多个子类别，如果有，则取子类别字段，没有，则直接取父级类别
        const subCategories = storageCategory.filter((item: any) => item.pid === seriesObj.sourceId) || [];
        const categoryArr = subCategories.length > 0 ? [...subCategories] : [{ ...seriesObj }];

        // 将skuList的数据按照productCatagoryId放进categoryArr项
        return categoryArr.map((category: any) => {
            const arr = skuList.reduce((pre: any, sku: any) => {
                // 这里的 category.sourceId 就是 category.productCatagoryId
                const flag = category.sourceId === sku.productCatagoryId && sku.enable;
                return flag
                    ? [
                          ...pre,
                          {
                              ...sku,
                              text: sku.name,
                              value: sku.name,
                              key: sku.skuId || sku.spuId,
                              images: handleMultiProductImages(sku.images),
                          },
                      ]
                    : pre;
            }, []);
            return { ...category, series: category.name, arr };
        });
    };

    useEffect(() => {
        if (id) {
            queryComparisonProductList({ productCatagoryId: id }).then((res: any) => {
                const data = JSONbig.parse(res).data;
                if (data && data.skuList && data.skuList.length) {
                    const selection = dealData(data.skuList);
                    setCompareSelectList(selection);
                }
            });
        }
    }, [id, series]);

    const descMap: any = {
        default: lang.seo_desc,
        solar: lang.seo_desc_solar,
        river: lang.seo_desc_river,
        delta: lang.seo_desc_delta,
    };

    const titleMap: any = {
        default: lang.seo_title,
        solar: lang.seo_title_solar,
        river: lang.seo_title_river,
        delta: lang.seo_title_delta,
    };

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={titleMap[series] || titleMap.default} description={descMap[series] || descMap.default} />
            <SEOlinksA locale={locale} list={seoconfig[series]?.include} pathname={router.asPath.substr(1)} />
            <ProductBanner />
            <div className={css.crumbox}>
                <h1 className="visuallyhidden">EcoFlow Comparison</h1>
                <Crum data={breadcrumbData} />
            </div>
            {id && <CompareList query={series} productCatagoryId={id} selectList={compareSelectList} lang={lang} />}
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (locale !== 'en') {
        if (!isReadyLang(locale)) {
            return redirectTo404();
        }
    }

    let categoryDataList: any = [];
    try {
        const resCategory = await getCategoryList(locale);
        if (resCategory.code === '0') {
            categoryDataList = resCategory?.data;
        }
    } catch (err) {
        console.log(err);
    }

    return {
        props: {
            categoryDataList,
        },
    };
}
